import Change3DSAnswerDialog from './Change3DSAnswerDialog';

export default Change3DSAnswerDialog;